import React from "react";
import withRouter from "../../withRouter";
import { Navigate } from "react-router";
import { getLoginAsUserDetails } from "../../action/admin/getActiveLoginUserList";

export class AdminUserView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			redirect: false,
			invalidActor: false
		};
	}

	componentDidMount() {
		const params = new URLSearchParams(window.location.search);
		const actor = params.get("actor");
		if (!actor) {
			this.setState({ invalidActor: true });
			return;
		}
		this.loadActorUserDetails(actor);
	}

	loadActorUserDetails = async (actorId) => {
		try {
			const response = await getLoginAsUserDetails(actorId);
			if (response?.statusCode === 200) {
				const user = response.data;
				sessionStorage.setItem("actor", actorId);
				sessionStorage.setItem("actor_email", user.email);
				sessionStorage.setItem("adminUserView", "true");
				this.setState({ redirect: true });
			} else {
				this.setState({ invalidActor: true });
			}
		} catch {
			this.setState({ invalidActor: true });
		}
	};

	render() {
		if (this.state.invalidActor) {
			return <Navigate to='/admin-dashboard' />
		}
		if (this.state.redirect) {
			return <Navigate to='/welcome' />
		}
		return null;
	}
}
export default withRouter(AdminUserView)
